import * as React from 'react'
import { Switch, Route } from 'react-router-dom'
import { History, Location } from 'history'
import { withNavigation } from 'hocs'
import { match as RouteMatch } from 'react-router-dom'
import { Navigation } from 'navigation'
import PersonalSection from './personalSection'
import PasswordSection from './passwordSection'
import ServiceAppsSection from './serviceApps'
import { ConnectAppLink } from './serviceApps/components/connectApp'
import './personalSettingsContainer.scss'
import { Profile } from 'settings/schema'
import { AccountSettingsService } from 'settings/settingsService'
import { UpdatedAccountDetails, PersonalSettingsParams } from 'settings/schema'
import { Container, ContainerHeading, ContainerBody, HeadingSectionName } from 'uiComponents/settingsContainer'
import { User } from 'auth/state'
import { withFeatures } from 'features'
import { t } from 'translations'

interface SettingsContainerState {
    welcome: boolean
    activeSection: string
}

interface SettingsContainerProps {
    accountSlug: string
    user: User | null
    accountSettingsService: AccountSettingsService
    history: History
    navigation: Navigation
    match: RouteMatch<PersonalSettingsParams>
    profile: Profile
    onSave: (newDetails: UpdatedAccountDetails, password: string) => void
    resendEmail: () => void
    location: Location
    welcomePage: boolean
    loading: boolean
    hasFeature: (feature: string, accountSlug: string) => boolean
}

class AccountSettingsContainer extends React.Component<SettingsContainerProps, SettingsContainerState> {
    constructor(props: SettingsContainerProps) {
        super(props)
        this.state = {
            welcome: this.props.welcomePage,
            activeSection: '',
        }
    }

    sections = ['personal', 'password', 'service_apps']

    onSectionChange = (section: string) => {
        if (this.state.activeSection === section) {
            return
        }
    }

    setActiveSection = (section: string) => {
        this.setState({ activeSection: section })
    }

    render() {
        const { welcome, activeSection } = this.state
        const { profile, onSave, resendEmail, location } = this.props
        const resellerPages = !!this.props.user?.resellerId && this.props.user.accounts.length > 1

        const serviceApps = location.pathname.includes('service_apps')

        return (
            <>
                <Container id="personal-settings" className={serviceApps ? 'has-page-footer' : undefined}>
                <ContainerHeading>
                    {!welcome && (
                        <>
                            <HeadingSectionName
                                className={activeSection === 'personal' ? 'active' : ''}
                                onClick={() => this.onSectionChange('personal')}
                                to={`${resellerPages ? '/resellers' : ''}/personal_settings/personal`}
                            >
                                {t('settings.personalSettings.tabs.personal')}
                            </HeadingSectionName>
                            <HeadingSectionName
                                className={activeSection === 'password' ? 'active' : ''}
                                onClick={() => this.onSectionChange('password')}
                                to={`${resellerPages ? '/resellers' : ''}/personal_settings/password`}
                            >
                                {t('settings.personalSettings.tabs.password')}
                            </HeadingSectionName>
                            <HeadingSectionName
                                className={activeSection === 'service_apps' ? 'active' : ''}
                                onClick={() => this.onSectionChange('service_apps')}
                                to={`${resellerPages ? '/resellers' : ''}/personal_settings/service_apps`}
                            >
                                {t('settings.personalSettings.tabs.serviceApps')}
                            </HeadingSectionName>
                        </>
                    )}
                    {welcome && (
                        <HeadingSectionName className="active" to="" disabled>
                            {t('settings.personalSettings.tabs.welcome')}
                        </HeadingSectionName>
                    )}
                </ContainerHeading>
                    <ContainerBody noPadding={location.pathname.includes('service_apps')}>
                    {!welcome && (
                        <Switch location={location}>
                            <Route
                                path="/personal_settings/personal"
                                render={() => (
                                    <PersonalSection
                                        profile={profile}
                                        onSave={onSave}
                                        resendEmail={resendEmail}
                                        welcome={welcome}
                                        setActiveSection={this.setActiveSection}
                                        loading={this.props.loading}
                                    />
                                )}
                            />
                            <Route
                                path="/personal_settings/password"
                                render={() => (
                                    <PasswordSection
                                        accountSettingsService={this.props.accountSettingsService}
                                        profile={profile}
                                        setActiveSection={this.setActiveSection}
                                    />
                                )}
                            />
                            <Route
                                path="/personal_settings/service_apps"
                                render={() => <ServiceAppsSection setActiveSection={this.setActiveSection} />}
                            />
                            <Route
                                path="/resellers/personal_settings/service_apps"
                                render={() => <ServiceAppsSection setActiveSection={this.setActiveSection} />}
                            />
                            <Route
                                path="/resellers/personal_settings/personal"
                                render={() => (
                                    <PersonalSection
                                        profile={profile}
                                        onSave={onSave}
                                        resendEmail={resendEmail}
                                        welcome={welcome}
                                        setActiveSection={this.setActiveSection}
                                        loading={this.props.loading}
                                    />
                                )}
                            />
                            <Route
                                path="/resellers/personal_settings/password"
                                render={() => (
                                    <PasswordSection
                                        accountSettingsService={this.props.accountSettingsService}
                                        profile={profile}
                                        setActiveSection={this.setActiveSection}
                                    />
                                )}
                            />
                        </Switch>
                    )}
                    {welcome && (
                        <PersonalSection
                            profile={profile}
                            onSave={onSave}
                            resendEmail={resendEmail}
                            welcome={welcome}
                            setActiveSection={this.setActiveSection}
                            loading={this.props.loading}
                        />
                    )}
                    </ContainerBody>
                </Container>
                {serviceApps && <ConnectAppLink />}
            </>
        )
    }
}

export default withFeatures(withNavigation(AccountSettingsContainer))
